export default __webpack_public_path__ + "static/media/gift.78b06ce9.svg";